export {
  default as eventVenue,
  ReactComponent as EventVenue,
} from '@assets/icons/use-cases/event-venue.svg'    
